import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = ["data-kt-indicator", "disabled"]
const _hoisted_7 = { class: "indicator-label" }
const _hoisted_8 = { class: "indicator-progress" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_10 = { class: "card-body pt-0" }
const _hoisted_11 = { class: "text-gray-600 mb-0" }
const _hoisted_12 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_13 = { class: "fw-bold text-gray-800" }
const _hoisted_14 = { class: "text-gray-600 ms-2 text-break" }
const _hoisted_15 = { class: "badge badge-light-primary ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.can('read', 'indices'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.translate('autoSyncPipeline')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.can('update', 'indices'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  disabled: _ctx.loading,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.runSync && _ctx.runSync(...args)))
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.translate('runSync')), 1),
                  _createElementVNode("span", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_9
                  ])
                ], 8, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.translate('autoSyncPipelineDescription')), 1),
          (_ctx.lastTask)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translate('autoSyncLastTask')), 1),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.lastTask.taskArn), 1),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.lastTask.status), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}